module.exports = __webpack_public_path__ + "img/1215-top.18a039cc.jpg";